import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";

import App from "./App";
import About from "./actions/views/about";
import Blog from "./actions/views/blog";
import Contact from "./actions/views/contact";
import ArticlePage from "./actions/components/blog/articlepage";

const router = createHashRouter([
  { path: "/", element: <App /> },
  { path: "/about", element: <About /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:id", element: <ArticlePage /> },
  { path: "/contact", element: <Contact /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </HelmetProvider>
);